import { Navigate } from "react-router-dom";

const AccessRoutes = ({ children, pageName, hasPageAccess }) => {

  if (pageName && !hasPageAccess(pageName)) {
    return <Navigate to="/not-authorized" replace />;
  }

  return children;
};

export default AccessRoutes;
